import { FormGroup } from "@angular/forms";
import {
  BmMgmFeeCommitmentForm,
  BmMgmFeeFg,
  BmMgmFeeGroupForm,
  BmMgmFeePcntForm, BmMgmFeesCatchUpForm, BmPcntOfMgmFeeForm,
  BudgetModelFormGroup,
} from "../../../pojo/bm-form";
import { BmCalcHelperService } from "../bm-calc-helper.service";
import { MgmFeeValuesFormService } from "../../mgmFee/mgmFee/mgm-fee-values-form.service";
import { CatchUpService } from "../../mgmFee/catchUp/catch-up.service";
import { BmMgmVatFormService } from "../../mgmFee/vat/bm-mgm-vat-form.service";
import { BmGroupTotalCalculationsService } from "../../mgmFee/total/bm-group-total-calculations.service";
import { BmGrandTotalMgmFeeCalcService } from "../../mgmFee/total/bm-grand-total-mgm-fee-calc.service";
import { BmTotalAccumulatedCapCalcService } from "../../total/accumulated/bm-total-accumulated-cap-calc.service";
import { MgmFeeCommitmentFormService } from "../../mgmFee/commitment/mgm-fee-commitment-form.service";
import { MgmFeePcntFormService } from "../../mgmFee/mgmFee/mgm-fee-pcnt-form.service";
import { BmCalcType } from "../../../pojo/bm-enums";
import { PcntOfMgmFeeFormService } from "../../mgmFee/mgmFee/pcnt-of-mgm-fee-form.service";
import { BmTotalGeneralCalcService } from "../../total/general/BmTotalGeneralCalcService";
import { BmSubscriptionsInvestmentHelperService } from "./bm-subscriptions-investment-helper.service";

export class BmSubscriptionsMgmFeeHelperService {

  /**
   * Subscribe on COMMITMENT changes in Mgm Fee Group
   *
   * - ITEMS CHANGED
   *    - LAST QUARTER     => Change year commitment value to the Q4 value and recalculate all
   *         If Q4 MANUAL      => year => CALCULATED,
   *         If Q4 NOT MANUAL  => year => GENERATED,
   *    - OTHER ITEMS      => recalculate all
   *
   * - STANDARD VALUE CHANGES  => Set in all Items, which are not MANUAL standard value
   *
   * @param commitment contains Items Array
   * @param mgmFeeGroup contains mgm fee group data (name, priority, subGroups)
   * @param mgmFee  contains mgm fee groups
   * @param budgetForm whole model
   */
  public static subscribeToMgmCommitment(commitment: FormGroup<BmMgmFeeCommitmentForm>,
    mgmFeeGroup: FormGroup<BmMgmFeeGroupForm>,
    mgmFee: FormGroup<BmMgmFeeFg>,
    budgetForm: BudgetModelFormGroup): void {

    // === ITEMS CHANGES ===
    commitment.controls.items.valueChanges.subscribe(() => {
      MgmFeeCommitmentFormService.updateYearsValues(commitment.controls.items);
      MgmFeeCommitmentFormService.updateIsCatchUpAvailable(commitment.controls.items, commitment.controls.standardValue.value);
      this.recalculateAll(mgmFeeGroup, mgmFee, budgetForm);
    });

    // === STANDARD VALUE CHANGES ===
    commitment.controls.standardValue.valueChanges.subscribe((newValue: number) => {
      MgmFeeCommitmentFormService.updateItemsOnStandardValueChange(commitment.controls.items, newValue);
      MgmFeeCommitmentFormService.updateIsCatchUpAvailable(commitment.controls.items, newValue);
      this.recalculateAll(mgmFeeGroup, mgmFee, budgetForm);
    });
  }

  /**
   * Subscribe on Management Fee Pcnt changes in Mgm Fee Group
   *
   * - ITEMS CHANGED           => 1) YEAR Changed year => MANUAL, quarters => yearValue/4 => CALCULATED
   *                              2) QUARTER changed   => MANUAL, year => sum => CALCULATED
   *                              3) recalculate all
   *
   * - STANDARD VALUE CHANGES  => 1) For each YEAR item that are GENERATED => change its value to newStdVal, calcType to GENERATED
   *                              2) For that same year, all QUARTER items become newStdVal / 4, calcType to GENERATED
   *                              3) recalculate all
   *
   * @param mgmFeePcnt contains Items Array
   * @param mgmFeeGroup contains mgm fee group data (name, priority, subGroups)
   * @param mgmFee  contains mgm fee groups
   * @param budgetForm whole model
   */
  public static subscribeToMgmFeePcnt(mgmFeePcnt: FormGroup<BmMgmFeePcntForm>,
    mgmFeeGroup: FormGroup<BmMgmFeeGroupForm>,
    mgmFee: FormGroup<BmMgmFeeFg>,
    budgetForm: BudgetModelFormGroup): void {

    // === ITEMS CHANGES ===
    mgmFeePcnt.controls.items.valueChanges.subscribe(() => {
      MgmFeePcntFormService.handleItemsChange(mgmFeePcnt.controls.items);
      this.recalculateAll(mgmFeeGroup, mgmFee, budgetForm);
    });

    // === STANDARD VALUE CHANGES ===
    mgmFeePcnt.controls.standardValue.valueChanges.subscribe((newStandardValue) => {
      if (mgmFeePcnt.controls.standardValue.invalid) {
        return;
      }
      MgmFeePcntFormService.handleStandardValueChange(mgmFeePcnt.controls.items, newStandardValue);
      this.recalculateAll(mgmFeeGroup, mgmFee, budgetForm);
    });
  }

  /**
   * Subscribe on Pcnt of Management Fee changes in Mgm Fee Group
   *
   * - ITEMS CHANGED           => 1) recalculate all values
   *                              3) recalculate Year pcnt (AFTER ALL RECALCULATIONS !!!)
   * - STANDARD VALUE CHANGES  => 1) set in all NOT manual quarters standardValue
   *                              2) recalculate all values
   *                              3) recalculate Year pcnt (AFTER ALL RECALCULATIONS !!!)
   * - IsSELECTED CHANGED.     => 1) recalculate all values
   **
   * @param pcntOfMgmFee contains Items Array
   * @param mgmFeeGroup contains mgm fee group data (name, priority, subGroups)
   * @param mgmFee  contains mgm fee groups
   * @param budgetForm whole model
   */
  public static subscribeToPcntOfMgmFee(pcntOfMgmFee: FormGroup<BmPcntOfMgmFeeForm>,
    mgmFeeGroup: FormGroup<BmMgmFeeGroupForm>,
    mgmFee: FormGroup<BmMgmFeeFg>,
    budgetForm: BudgetModelFormGroup): void {

    // === ITEMS CHANGES ===
    pcntOfMgmFee.controls.items.valueChanges.subscribe(() => {
      this.recalculateAll(mgmFeeGroup, mgmFee, budgetForm);
      PcntOfMgmFeeFormService.recalculateYear(pcntOfMgmFee, mgmFeeGroup);
    });

    // === STANDARD VALUE CHANGES ===
    pcntOfMgmFee.controls.standardValue.valueChanges.subscribe((newStdVal: number) => {
      if (pcntOfMgmFee.controls.standardValue.invalid) {
        return;
      }
      pcntOfMgmFee.controls.items.controls.forEach((item) => {
        if (item.getRawValue().calcType !== BmCalcType.MANUAL) {
          BmCalcHelperService.patchAndDisable(item, newStdVal, BmCalcType.GENERATED);
        }
        this.recalculateAll(mgmFeeGroup, mgmFee, budgetForm);
        PcntOfMgmFeeFormService.recalculateYear(pcntOfMgmFee, mgmFeeGroup);
      });
    });

    // === Is Selected VALUE CHANGES ===
    pcntOfMgmFee.controls.isSelected.valueChanges.subscribe(() => {
      this.recalculateAll(mgmFeeGroup, mgmFee, budgetForm);
    });
  }

  /**
   * Subscribe on CATCH UP changes in Mgm Fee Group
   *
   * @param catchUpFg contains Items Array
   * @param mgmFeeGroup contains mgm fee group data (name, priority, subGroups)
   * @param mgmFee  contains mgm fee groups
   * @param budgetForm whole model
   */
  public static subscribeToCatchUp(catchUpFg: FormGroup<BmMgmFeesCatchUpForm>,
    mgmFeeGroup: FormGroup<BmMgmFeeGroupForm>,
    mgmFee: FormGroup<BmMgmFeeFg>,
    budgetForm: BudgetModelFormGroup): void {

    // === Is Selected VALUE CHANGES ===
    catchUpFg.controls.isSelected.valueChanges.subscribe(() => {
      this.recalculateAll(mgmFeeGroup, mgmFee, budgetForm);
    });
  }

  /**
   * Subscribe on VAT changes in Mgm Fee Group
   *
   * - ITEMS CHANGED           => 1)
   * - STANDARD VALUE CHANGES  => 1)
   *
   *
   * @param vatPcntFG contains Items Array
   * @param mgmFeeGroup contains mgm fee group data (name, priority, subGroups)
   * @param mgmFee  contains mgm fee groups
   * @param budgetForm whole model
   */
  public static subscribeToVat(vatPcntFG: FormGroup<BmPcntOfMgmFeeForm>,
    mgmFeeGroup: FormGroup<BmMgmFeeGroupForm>,
    mgmFee: FormGroup<BmMgmFeeFg>,
    budgetForm: BudgetModelFormGroup): void {

    // === ITEMS CHANGES ===
    vatPcntFG.controls.items.valueChanges.subscribe(() => {
      BmMgmVatFormService.recalculateVatValues(mgmFeeGroup);
      BmMgmVatFormService.recalculateVatYearPcnt(mgmFeeGroup);
      this.recalculateTotals(mgmFeeGroup, mgmFee, budgetForm);

    });

    // === STANDARD VALUE CHANGES ===
    vatPcntFG.controls.standardValue.valueChanges.subscribe((newStdVal: number) => {
      if (vatPcntFG.controls.standardValue.invalid) {
        return;
      }
      BmMgmVatFormService.setNewStandardValue(vatPcntFG.controls.items, newStdVal);
      BmMgmVatFormService.recalculateVatValues(mgmFeeGroup);
      BmMgmVatFormService.recalculateVatYearPcnt(mgmFeeGroup);
      this.recalculateTotals(mgmFeeGroup, mgmFee, budgetForm);
    });

    // === Is Selected VALUE CHANGES ===
    vatPcntFG.controls.isSelected.valueChanges.subscribe(() => {
      this.recalculateAll(mgmFeeGroup, mgmFee, budgetForm);
    });
  }

  /**
   * RECALCULATE ALL VALUES which are connected to commitment
   *
   * - mgm fee values
   * - catch up (if selected)
   * - vat values (if selected)
   *
   * @param mgmFeeGroup
   * @param mgmFee
   * @param budgetForm
   * @private
   */
  private static recalculateAll(mgmFeeGroup: FormGroup<BmMgmFeeGroupForm>, mgmFee: FormGroup<BmMgmFeeFg>, budgetForm: BudgetModelFormGroup): void {
    const isCatchUpSelected = mgmFeeGroup.controls.subGroups.controls.catchUp.controls.isSelected.getRawValue();
    const isVatSelected = mgmFeeGroup.controls.subGroups.controls.vatPcnt.controls.isSelected.getRawValue();

    MgmFeeValuesFormService.mgmFeeValuesRecalculate(mgmFeeGroup);

    if (isCatchUpSelected) {
      CatchUpService.catchUpValuesRecalculate(mgmFeeGroup);
    }
    if (isVatSelected) {
      BmMgmVatFormService.recalculateVatValues(mgmFeeGroup);
    }
    this.recalculateTotals(mgmFeeGroup, mgmFee, budgetForm);
  }


  /**
   * RECALCULATE CAPITAL REQUIRED VALUES which are connected to commitment
   * - group total
   * - grand total (total for all mgm fee groups)
   *
   * - total Capital Required
   * - total accumulated required
   * @param mgmFeeGroup
   * @param mgmFee
   * @param budgetForm
   * @private
   */
  private static recalculateTotals(mgmFeeGroup: FormGroup<BmMgmFeeGroupForm>, mgmFee: FormGroup<BmMgmFeeFg>, budgetForm: BudgetModelFormGroup): void {
    BmGroupTotalCalculationsService.groupTotalRecalculate(mgmFeeGroup);
    BmGrandTotalMgmFeeCalcService.recalculateGrandTotal(mgmFee);

    BmTotalGeneralCalcService.recalculateTotalExpenses(budgetForm, budgetForm.controls.modelData.controls.totalExpenses, false);
    BmSubscriptionsInvestmentHelperService.recalculateInvestmentValue(budgetForm);
    BmTotalGeneralCalcService.recalculateTotalExpenses(budgetForm, budgetForm.controls.modelData.controls.totalCapRequired, true);
    BmTotalGeneralCalcService.recalculateAllRowValuePcnt(budgetForm);
    BmTotalAccumulatedCapCalcService.recalculateTotalAccumulatedRequired(budgetForm);
  }
}
